// useAmbience — declaratively bind a looping bed to a component's
// lifetime. Pass the track for the current scene (or null); the bed
// crossfades on change and fades out on unmount.

import { useEffect } from 'react'
import { setAmbience, type AmbienceTrack } from './ambience'

export function useAmbience(track: AmbienceTrack | null): void {
  useEffect(() => {
    setAmbience(track)
  }, [track])
  // Fade out when the owning component unmounts entirely.
  useEffect(() => {
    return () => setAmbience(null)
  }, [])
}
